import { SxProps, Theme } from '@mui/material';

export const containerBox: SxProps<Theme> = {
  paddingLeft: '25px',
};

export const captionText: SxProps<Theme> = {
  color: 'text.secondary',
  mb: 0.5,
  display: 'block',
};

export const getToggleButtonGroupStyles = (
  isLightTheme: boolean,
): SxProps<Theme> => ({
  '& .MuiToggleButton-root': {
    color: 'primary.main',
    borderColor: 'primary.main',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
    '&.Mui-selected': {
      color: 'white',
      backgroundColor: isLightTheme ? 'primary.main' : 'primary.dark',
      borderColor: 'primary.main',
      '&:hover': {
        backgroundColor: isLightTheme ? 'primary.dark' : 'primary.main',
        borderColor: 'primary.dark',
      },
    },
  },
});

export const chartBox: SxProps<Theme> = {
  width: '100%',
  position: 'relative',
  minHeight: 100,
};

export const spinnerBox: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 100,
};

export const errorBox: SxProps<Theme> = {
  borderRadius: '5px',
  padding: '5px',
  background: 'rgb(255 0 0 / 50%)',
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};
